<main id="partners-maintenance" class="maintenance-form">
    <h2>Edit Partners</h2>
    <div id="partners-names-grid">
        <span>Username:</span>
        <input type="text" class="partner-input" id="partner-username"
            bind:value={username} on:change={usernameChanged}>

        <span>Partner:</span>
        <input type="text" class="partner-input"  id="partner-name-input"
            bind:value={partner.name}>

        <span>System:</span>
        <input type="text" id="system-input" bind:value={partner.system}>
    </div>
    <div id="notes-and-chat">
        <h5>Partner's notes</h5>
        <textarea class="notes" id="partners-notes-edit" bind:value={partner.notes}></textarea>
    </div>
    <div class="buttons">
        <button class="select-button" on:click={refreshData}>Refresh</button>
        <button class="select-button" on:click={saveData}>Save</button>
        <button class="select-button" on:click={newPartner}>New</button>
        <button class="select-button" on:click={deletePartner}>Delete</button>
        <button class="select-button" on:click={close}>Close</button>
    </div>
</main>

<style>
    h5 {
        padding-bottom: 0;
    }

    #partners-maintenance {
        display: none;
    }

    #partners-names-grid {
        display: grid;
        grid-template-columns: auto auto;
        justify-content: start;
        grid-column-gap: 0.5vw;
    }

    main {
        width: 75vw;
    }
    .partner-input {
        width: 12vw;
    }
    #system-input {
        width: 50vw;
    }

    .notes {
        width: 33vw;
        height: 33vh;
        background-color: white;
    }
</style>

<script>
    import { buildMessage } from './common.js';
    import { user, state } from './data-store.js'
    import { writeToUser } from './user.js';
    import { elementDisplay, getValue } from './utilities'

    export let username = ''
    let partner_name = ''
    let system = ''
    $: partners = $user.partners
    $: partner = getPartnerData(username)
    let partner = {};

    function getPartnerData(username) {
        username = username.toLowerCase();
        let partner = {
            name: '',
            system: '',
            notes: '',
        }
        if (username in partners) {
            partner.name = partners[username].name;
            partner.system = partners[username].system;
            partner.notes = partners[username].notes;
            partner.chat = partners[username].chat;
        };
        return partner;
    };

    function refreshData() {
        username = getValue('partner-username')
        getPartnerData(username)
    }

    function usernameChanged() {
        getPartnerData(getValue('partner-input'))
    }

    function saveData() {
        if (!username || !partner.name || !partner.system) {
            return;
        }
        $user.partners[username] = partner;
        $state.partner = partner_name;
        buildMessage();
        writeToUser();
        close();
    }

    function partnersUserName(username) {
        let first_letter = username.substring(0, 1).toUpperCase();
        let remainder = username.substring(1, username.length).toLowerCase();
        return `${first_letter}${remainder}`;
    }

    function newPartner() {
        username = '';
        partner = '';
        system = '';
    };

    function deletePartner() {
        if (!(username in $user.partners)) {
            alert('There is no partner with this name');
            return;
        }
        if (!confirm('Delete this partner?')) {
            return;
        }
        delete $user.partners[username];
        username = '';
        partner_name = '';
        system = '';
        writeToUser();
        $user = $user;
        close();
    };

    function close() {
        elementDisplay('partners-maintenance', 'none');
    };
</script>